import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Dialog from '..'
import getLoginPortalUrl from '../../../utils/getLoginPortalUrl'
import getCurrentDomain from '../../../utils/getCurrentDomain'

const GeolocationDialog = ({ contentType }) => {
  const title = `This ${contentType === 'live' ? 'live channel' : 'programme'} is not available as you are located outside of the STV Broadcast Licence Region`

  return (
    <div className="GeolocationDialog">
      <Dialog
        title={title}
        subtitle={(
          <Fragment>
            If you think we got your details wrong, please check your account <a style={{ textDecoration: 'underline' }} href={getLoginPortalUrl(getCurrentDomain())}>in here</a>.
          </Fragment>
        )}
        supplementaryText={(
          <Fragment>
            You may be able to watch on <a href="/categories/">catch-up</a>, or access our <a href="/categories/archive/">classic catalogue here</a>. Alternatively, the programme may be available to watch live on <a href="https://www.itv.com/" target="_blank" rel="noopener noreferrer">itv.com</a>.
          </Fragment>
        )}
      />
    </div>
  )
}

GeolocationDialog.propTypes = {
  contentType: PropTypes.string,
}

GeolocationDialog.defaultProps = {
  contentType: 'episode',
}

export default GeolocationDialog
